import React, { useEffect } from "react";

import ViewAppBar from "../views/ViewAppBar";

import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";
import HeroSection from "../views/HeroSection";
import ViewVender from "../views/ViewVender";
import FormSection from "../views/FormSection";
import ViewProvaSocial from "../views/ViewProvaSocial";
import ViewDivulgacao from "../views/ViewDivulgacao";
import ViewTroca from "../views/ViewTroca";
import { useLocation } from "react-router-dom";



const Periodos: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#formulario") {
      const target = document.querySelector(location.hash);
      if (target) {
        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 300);
      }
    }
  }, [location]);
  
  
  return(

  
  <>
    <ContatoZap />
    <div>
      <ViewAppBar />

      
      <ViewDivulgacao/>
      <ViewTroca/>
     
      <FormSection tipo="periodos"/>
      

      <ViewFooter />
    </div>
  </>
)};
export default Periodos;
